<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalOtherInsurance",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"22. (a) Have Lloyd's or any other Insurer ever cancelled or refused to issue or to continue any Insurance for you?",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderCancelOrRefuseDetailsId",
					props: {
						suggest: {
							typeIncludes: "cancelOrRefuseDetails"
						},
						createOptions: {
							type: "cancelOrRefuseDetails",
							dataType: "string"
						}
					}
				},
				{
					label:
						"22. (b) Have you previously been insured? If so, state with whom, risk covered, and for what amount.",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: "case.facts.holderPastInsuranceDetailsId",
					props: {
						suggest: {
							typeIncludes: "pastInsuranceDetails"
						},
						createOptions: {
							type: "pastInsuranceDetails",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
